module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Ruddy_Gore2#Contents-A"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "fp"
  }, [_vm._v("‘They do it with mirrors, my boy.’")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("\t\tColonel Pewter in Ironicus, Arthur Hormer")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dd262be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ruddy_Gore-5.vue
// module id = 72
// module chunks = 0